import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { IAICampaignGenerationJob } from '../../models/AICampaign';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateAICampaignQuota } from './useAICampaignQuota';

export const useStartAICampaignGeneration = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IAICampaignGenerationJob) => void;
} = {}) => {
	const userSession = useUserSession();

	// Failures arrive as IOperationResultNoValue, not Error, and there is no MutationCache to route them.
	return useMutation<IAICampaignGenerationJob, Api.IOperationResultNoValue, string>({
		mutationFn: (bulkEmailMessageId: string) => {
			return userSession.webServiceHelper.callAsync<IAICampaignGenerationJob>(
				`AICampaign/${encodeURIComponent(bulkEmailMessageId)}/generate`,
				'POST',
				null
			);
		},
		onError: error => {
			invalidateAICampaignQuota();
			onError?.(error);
		},
		onSuccess: data => {
			invalidateAICampaignQuota();
			onSuccess?.(data);
		},
	});
};
